import React, { Component } from "react";
import { connect } from "react-redux";
import { translate, Trans } from "react-i18next";

import { getCgnAccess, cleanAccess } from "actions/cgn";

import Wrapper from "components/Wrapper";
import Title from "components/Title";
import Input from "components/Input";
import Label from "components/Label";
import InlineLink from "components/InlineLink";
import Button from "components/Button";
import Loader, { LoaderStyle } from "components/Loader";

import consts from "consts/consts";

import style from "./style.css";

@translate()
@connect((state) => ({
  isLoading: state.cgn.user.loading,
  wsError: state.cgn.user.error,
}))
export default class PageIdentificationCgn extends Component {
  state = {
    error: undefined,
  };

  constructor(data) {
    super(data);
    this.weCareIDValue = "";
  }

  componentDidMount() {
    this.props.dispatch(cleanAccess());
  }

  onLoginClick() {
    if (!this.props.isLoading) {
      const { t } = this.props;
      const onlyAlphaNumericRegexp = new RegExp(/^[a-z0-9]+$/i);
      const containsOnlyAlphaNumeric = onlyAlphaNumericRegexp.test(this.weCareIDValue);
      if (this.weCareIDValue.length === 0 || containsOnlyAlphaNumeric === false) {
        this.setState({
          error: t("Please enter login ID as its required field."),
        });
        return;
      }
      if (this.weCareIDValue.length !== 8) {
        this.setState({
          error: t("Error Message for length check"),
        });
        return;
      }
      // Reset error on WS hit
      this.setState({ error: undefined });
      this.props.dispatch(getCgnAccess(this.weCareIDValue)).then((response) => {
        if (response.status) {
          this.props.history.push(consts.routes.cgn.url);
        } else {
          if (response.error.code && response.error.code === 429) {
            this.setState({
              error: t("Too many request"),
            });
          }
        }
      });
    }
  }

  onInputChange(event) {
    this.weCareIDValue = event.target.value;
  }

  render() {
    const validationError = this.state.error;
    const { isLoading, wsError } = this.props;
    return (
      <Wrapper>
        <Title>
          <Trans>You want to deactivate your CGN</Trans>
        </Title>
        <Label>
          <Trans>Why the CGN</Trans>
        </Label>
        <p className={style.paragraph}>
          <Trans>_cgn_login_why_cgn_txt_p1</Trans>
        </p>
        <p className={style.paragraph}>
          <Trans>_cgn_login_why_cgn_txt_p2</Trans>
        </p>
        <Label>
          <Trans>CGN Impact</Trans>
        </Label>
        <p className={style.paragraph}>
          <Trans>_cgn_login_cgn_impact_txt_p1</Trans>
        </p>
        <p className={style.paragraph}>
          <Trans>_cgn_login_cgn_impact_txt_p2</Trans>
        </p>
        <Label>
          <Trans>How to do</Trans>
        </Label>
        <p className={style.paragraph}>
          <Trans>_cgn_login_cgn_how_todo_txt_p1</Trans> <InlineLink to="/reset"><Trans>_cgn_login_cgn_how_todo_txt_p1_link</Trans></InlineLink> <Trans>_cgn_login_cgn_how_todo_txt_p1_end</Trans>.
        </p>
        <Label>
          <Trans>Enter your WeCareID-code to change your appointment</Trans>
        </Label>
        <Input type="text" onChange={this.onInputChange.bind(this)} onSubmit={this.onLoginClick.bind(this)} />
        <Button rootClassname={style.button} onClick={this.onLoginClick.bind(this)}>
          {isLoading && <Loader rootClassname={style.loader} style={LoaderStyle.WHITE} />}
          {!isLoading && <Trans>Login</Trans>}
        </Button>
        {validationError && <p className={style.errorMessage}>{validationError}</p>}
        {!wsError && (
          <p>
            <InlineLink to="/reset/cgn">
              <Trans>If you can't find your WeCareID-code anymore</Trans>
            </InlineLink>
          </p>
        )}
        {wsError &&
        !validationError && (
          <p className={style.errorMessage}>
            <Trans>Something went wrong in submitting your ID. If you can't find your WeCareID-code anymore</Trans>{" "}
            <InlineLink to="/reset/cgn">
              <Trans>please click here</Trans>
            </InlineLink>{" "}
            <Trans>or call 5000</Trans>
          </p>
        )}
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/PageIdentificationCgn/index.js